<template>
  <div>
    <h2 class="component-title">
      Način plaćanja
    </h2>
    <p class="about-next-step">
      Plaćanje ćeš završiti na sljedećem koraku
    </p>
    <p
      v-if="paymentMethodsLoading"
      role="status"
    >
      {{ $t('paymentMethodsLoading') }}
    </p>
    <p
      v-else-if="!providerMethods.length"
      role="alert"
    >
      {{ $t(paymentMethodsError ? 'paymentMethodsError' : 'paymentMethodsUnavailable') }}
    </p>
    <div class="payment-methods">
      <div
        v-for="option in providerMethods"
        :key="option.id"
        class="payment-method"
        @click="selectPaymentMethod(option.id)"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">{{ buyer.paymentMethod === option.id ? 'check_circle' : 'radio_button_unchecked' }}</span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">
              {{ paymentTitle(option) }}
            </h3>
            <p class="payment-about">
              {{ paymentDescription(option) }}
            </p>
          </div>
        </div>
        <div class="payment-logo">
          <img
            v-if="paymentLogo(option)"
            :src="paymentLogo(option)"
            :alt="option.label"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentMethodsMixin from '@/payment-methods-mixin'
export default {
  name: 'store-payment-methods',
  mixins: [paymentMethodsMixin],
  props: { buyer: { type: Object, default: () => ({}) } },
  computed: {
    paymentEligibility() { return { keksPay: true } },
  },
  methods: {
    selectPaymentMethod(method) { this.$set(this.buyer, 'paymentMethod', method) },
  },
}
</script>

<style scoped>
.component-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 28.8px */
  letter-spacing: -0.72px;
  margin-bottom: 8px;
}
.about-next-step {
  color: #333;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 40px;
}

.payment-methods {
  display: flex;
  flex-direction: column;
}
.payment-method {
  display: flex;
  padding: 16px 24px 16px 16px;
  justify-content: space-between;
  gap: 16px;
  border-top: 2px solid #333;
  background: #fff;
  cursor: pointer;
}

.payment-method-zkm {
  max-width: inherit !important;
}
@media screen and (max-width: 455px) {
  .payment-method {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .payment-logo {
    align-self: center;
  }
}
.check-box {
  margin-right: 1.125rem;
  margin-top: 5px;
}
.payment-description {
  display: flex;
}
.payment-logo {
  margin-right: 1.5rem;
}
.payment-text {
  padding-right: 0.25rem;
}
.payment-type {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Rubik;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 550;
  line-height: 120%; /* 24px */
  letter-spacing: -0.6px;
}
.payment-about {
  color: #333;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Rubik;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 19.2px */
  letter-spacing: 0.24px;
}
</style>
